import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import MotionLazy from "@/components/animate/motion-lazy";
import { SettingsProvider } from "@/components/settings";
import SnackbarProvider from "@/components/snackbar/snackbar-provider";
import ThemeProvider from "@/theme";
import MuiXLicense from "./utils/muiLicense";

import "./App.css";
import Router from "./routes/sections";
import useScrollToTop from "./hooks/scroll-to-top";
import ErrorDisplay from "./components/error/error-display";
import { ErrorBoundaryWrapper } from "./components/error/error-boundary";
import { useLocalHLS } from "./hooks/use-local-hls";
import CelebrationCoordinator from "./components/celebration/CelebrationCoordinator";

function App() {
  useLocalHLS();
  useScrollToTop();

  return (
    <div className="hl-app-container">
      <MuiXLicense />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider
          defaultSettings={{
            themeMode: "light",
            themeDirection: "ltr",
            themeContrast: "default",
            themeLayout: "vertical",

            themeColorPresets: "blue",
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ErrorBoundaryWrapper errorMessage="An unknown error occurred while displaying the page">
                  <CelebrationCoordinator>
                    <Router />
                  </CelebrationCoordinator>
                </ErrorBoundaryWrapper>
                <ErrorDisplay />
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
